import client from './client'
import { GetAddressResponse } from './types'

export * from './types'

export const getAddress = async (postalCode: string) => {
  const [first, second] = postalCode.includes('-')
    ? postalCode.split('-')
    : [postalCode.substr(0, 3), postalCode.substr(3)]

  const res: GetAddressResponse = await client.get(`/${first}/${second}.json`)
  return res
}
